import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DialogsProvider, ToastProvider } from '../../providers';
import { withContextProvider } from '../../hoc';
import PageHeader from './PageHeader';
import { useToasts } from '../../hooks';
import { getImportStatus } from '../../utils/api/imports';
import { useLocalStorage } from '../../hooks/useLocalStorage';

const customError = 'We weren’t able to import your file. Please review the errors and try again.';

const PageHeaderWrapper = ({ organizationId }) => {
  const { showToast } = useToasts();
  const { getFromLocalStorage, removeFromLocalStorage } = useLocalStorage();

  useEffect(() => {
    const pendingImportId = getFromLocalStorage('pendingImportId');
    if (!pendingImportId) return;

    getImportStatus({ importId: pendingImportId, customError })
      .then((importData) => {
        // If pendingImportId is gone, ImportPicker already handled this import — skip to avoid double toast.
        if (!getFromLocalStorage('pendingImportId')) return;

        if (importData.status === 'Complete') {
          showToast({ message: 'Import complete.', type: 'success' });
        } else {
          showToast({ message: customError, type: 'error' });
        }
        window.dispatchEvent(new CustomEvent('importCompleted'));
      })
      .catch(() => {
        if (!getFromLocalStorage('pendingImportId')) return;
        showToast({ message: customError, type: 'error' });
      })
      .finally(() => {
        removeFromLocalStorage('pendingImportId');
      });
  }, [getFromLocalStorage, removeFromLocalStorage, showToast]);

  return (
    <DialogsProvider>
      <PageHeader organizationId={organizationId} showToast={showToast} />
    </DialogsProvider>
  );
};

PageHeaderWrapper.propTypes = {
  organizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default withContextProvider(ToastProvider)(PageHeaderWrapper);
